import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';

@Component({
    selector: 'load-more',
    templateUrl: './load-more.html',
    styleUrls: ['./load-more.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadMoreComponent {
    @Input() listing?: ProductListing;
}
